const state = {
    scrollTop: 0,
    time: 0,
    dParams: 20,
    scrollState: 0
}

const getters = {

}

const mutations = {
    change_scrollTop(state){
        state.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    },

    change_time(state,time){
        state.time = time
    },

    change_dParams(state,dParams){
        state.dParams = dParams
    },

    change_scrollState(state,scrollState){
        state.scrollState = scrollState
    }

}

const actions = {

    toTop(context,payload){
        let event = payload.event
        // let scrollState = context.state.scrollState
        // let time = context.state.time

        if(!!context.state.scrollState){
            return
        }

        let scrollState = 1
        context.commit('change_scrollState',scrollState)

        event.preventDefault()
        let time = setInterval(()=>{
            console.log("context",context)
            context.dispatch('gotoTop',{distance:context.state.scrollTop - context.state.dParams})
            console.log(context.state.dParams)
        },10)

        context.commit('change_time',time)
    },

    gotoTop(context,payload){
        console.log("进gotoTop")
        let distance = payload.distance
        console.log("distance",distance)

        // let dParams = context.state.dParams
        let scrollState = context.state.scrollState
        // let time = context.state.time

        context.state.dParams += 20
        // context.commit('change_dParams',dParams)
        

        distance = distance>0 ? distance : 0
        document.documentElement.scrollTop = document.body.scrollTop = window.pageYOffset = distance
        console.log(document.documentElement.scrollTop,document.body.scrollTop,window.pageYOffset,distance)

        if(context.state.scrollTop < 10){
            clearInterval(context.state.time)
            // context.commit('change_time',time)

            context.state.dParams = 20
            // context.commit('change_dParams',dParams)
            
            scrollState = 0
            context.commit('change_scrollState',scrollState)
        }

    }



}

export default{
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}